import Swal from 'sweetalert2'
export const alert = {
    namespaced: true,
    state: {
        type: null,
        message: null
    },
    actions: {
        success({ commit }, message) {
            commit("success", message);
        },
        error({ commit }, message) {
            commit("error", message);
        },
        clear({ commit }) {
            commit("clear");
        }
    },
    mutations: {
        success(state, message) {
            state.type = "alert-success";
            state.message = message;
            Swal.fire('InstantCare', message, 'success')
        },
        error(state, message) {
            state.type = "alert-danger";
            state.message = message;
            Swal.fire('InstantCare', message, 'error')
        },
        clear(state) {
            state.type = null;
            state.message = null;
        }
    }
};
